import styles from '@activities/gift/GiftSentActivity/components/RefundButton/styles.module.scss';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

const GiftCanceledModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column fullWidth align='center'>
                        <Text size='3xl' fontWeight='bold'
                              className={styles.title}>
                            결제가 취소되었습니다.
                        </Text>
                        <Text size='xl' align='center'>
                            취소하신 내역은 선물함&gt;보낸선물에서 확인하실 수 있습니다.
                        </Text>
                    </Column>
                    <Button fullWidth onClick={pop}>
                        확인
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default GiftCanceledModal;
